/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkDay } from '../../models/work-day';

export interface ApiV0WorkDayUpdateWorkDayPost$Params {
      body?: WorkDay
}

export function apiV0WorkDayUpdateWorkDayPost(http: HttpClient, rootUrl: string, params?: ApiV0WorkDayUpdateWorkDayPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV0WorkDayUpdateWorkDayPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV0WorkDayUpdateWorkDayPost.PATH = '/api/v0/workDay/updateWorkDay';
